import { render, staticRenderFns } from "./CompaniesIndex.vue?vue&type=template&id=4e549fe0&scoped=true&"
import script from "./CompaniesIndex.vue?vue&type=script&lang=js&"
export * from "./CompaniesIndex.vue?vue&type=script&lang=js&"
import style0 from "./CompaniesIndex.vue?vue&type=style&index=0&id=4e549fe0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e549fe0",
  null
  
)

export default component.exports